import { Component, type ErrorInfo, type ReactNode } from 'react';
import { LuTriangleAlert } from 'react-icons/lu';
import './ErrorBoundary.css';

interface Props { children: ReactNode }
interface State { erro: Error | null }

/**
 * A rede de proteção do app.
 *
 * **Não existia nada disso até 2026-09-12** — nem `ErrorBoundary`, nem
 * `errorElement` de rota. Um componente que quebrasse ao renderizar deixava a
 * pessoa com a **tela branca**: sem mensagem, sem botão de recarregar, sem
 * caminho de volta. É o pior tipo de problema porque não parece um problema,
 * parece o app sumindo.
 *
 * Precisa ser classe: `componentDidCatch` não tem equivalente em hook.
 *
 * O detalhe técnico do erro fica no `console`, não na tela — quem está usando
 * não tem o que fazer com um stack trace, e mostrar um é o mesmo vício dos 14
 * `toast.error(\`Erro: ${e.message}\`)` que a proposta apontou.
 */
class ErrorBoundary extends Component<Props, State> {
    state: State = { erro: null };

    static getDerivedStateFromError(erro: Error): State {
        return { erro };
    }

    componentDidCatch(erro: Error, info: ErrorInfo) {
        console.error('[ErrorBoundary] a tela quebrou ao renderizar:', erro, info.componentStack);
    }

    render() {
        if (!this.state.erro) return this.props.children;

        return (
            <div className="eb">
                <div className="eb-caixa">
                    <span className="eb-ico" aria-hidden="true"><LuTriangleAlert size={20} /></span>
                    <h1 className="eb-titulo">Esta tela parou de responder</h1>
                    <p className="eb-texto">
                        Alguma coisa quebrou ao montar a página. O que você já tinha salvo está a
                        salvo — o problema é só aqui na exibição.
                    </p>
                    <div className="eb-acoes">
                        {/* `reload` e não `setState({erro:null})`: se o componente quebrou ao
                            montar, remontá-lo com o mesmo estado quebra de novo na hora. */}
                        <button type="button" className="eb-btn is-primary" onClick={() => window.location.reload()}>
                            Recarregar a tela
                        </button>
                        <button type="button" className="eb-btn" onClick={() => { window.location.href = '/home'; }}>
                            Ir para o início
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ErrorBoundary;
